import * as React from "react"
import { cn } from "./utils"

interface ProgressProps extends React.ProgressHTMLAttributes<HTMLProgressElement> {
  value?: number
  max?: number
  className?: string
}

const Progress = React.forwardRef<HTMLProgressElement, ProgressProps>(
  ({ className, value = 0, max = 100, ...props }, ref) => {
    const percentage = Math.min(Math.max((value / max) * 100, 0), 100)

    return (
      <progress
        ref={ref}
        value={percentage}
        max={100}
        className={cn(
          "h-4 w-full overflow-hidden rounded-full [appearance:none]",
          "[&::-webkit-progress-bar]:bg-muted/40 [&::-webkit-progress-bar]:rounded-full",
          "dark:[&::-webkit-progress-bar]:bg-muted/40",
          "[&::-webkit-progress-value]:bg-primary/10 [&::-webkit-progress-value]:rounded-full [&::-webkit-progress-value]:transition-all",
          "dark:[&::-webkit-progress-value]:bg-primary/10",
          "[&::-moz-progress-bar]:bg-primary/10 [&::-moz-progress-bar]:rounded-full [&::-moz-progress-bar]:transition-all",
          "dark:[&::-moz-progress-bar]:bg-primary/10",
          className,
        )}
        {...props}
      />
    )
  }
)
Progress.displayName = "Progress"

export { Progress }
